import { MessageCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

export const FloatingWhatsApp = () => {
  // Direct link to the specific WhatsApp number without any pre-filled message
  const whatsappUrl = 'https://wa.me/+5527999205884'

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 animate-fade-in-up"
      aria-label="Falar no WhatsApp"
    >
      <Button
        size="lg"
        className="h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#20bd5a] text-white shadow-lg hover:shadow-xl transition-all hover:scale-110 p-0"
      >
        <MessageCircle className="h-8 w-8" />
      </Button>
    </a>
  )
}
